import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddCityComponent = () => {
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [circles, setCircles] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState('');
  const [clusters, setClusters] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState('');
  const [cityName, setCityName] = useState('');

  useEffect(() => {
    fetchZones();
  }, []);

  useEffect(() => {
    if (selectedZone) {
      fetchCircles(selectedZone);
    }
  }, [selectedZone]);

  useEffect(() => {
    if (selectedZone && selectedCircle) {
      fetchClusters(selectedZone, selectedCircle);
    }
  }, [selectedZone, selectedCircle]);

  const fetchZones = async () => {
    try {
      const response = await axios.get('https://rachpower-dad00-default-rtdb.firebaseio.com/zones.json');
      const data = response.data;
      const loadedZones = [];
      for (const key in data) {
        loadedZones.push({
          id: key,
          ...data[key]
        });
      }
      setZones(loadedZones);
    } catch (error) {
      console.error('Error fetching zones:', error);
    }
  };

  const fetchCircles = async (zoneId) => {
    try {
      const response = await axios.get(`https://rachpower-dad00-default-rtdb.firebaseio.com/zones/${zoneId}/circles.json`);
      const data = response.data;
      const loadedCircles = [];
      for (const key in data) {
        loadedCircles.push({
          id: key,
          ...data[key]
        });
      }
      setCircles(loadedCircles);
    } catch (error) {
      console.error('Error fetching circles:', error);
    }
  };

  const fetchClusters = async (zoneId, circleId) => {
    try {
      const response = await axios.get(`https://rachpower-dad00-default-rtdb.firebaseio.com/zones/${zoneId}/circles/${circleId}/clusters.json`);
      const data = response.data;
      const loadedClusters = [];
      for (const key in data) {
        loadedClusters.push({
          id: key,
          ...data[key]
        });
      }
      setClusters(loadedClusters);
    } catch (error) {
      console.error('Error fetching clusters:', error);
    }
  };

  const handleAddCity = async () => {
    if (selectedZone && selectedCircle && selectedCluster && cityName) {
      try {
        await axios.post(`https://rachpower-dad00-default-rtdb.firebaseio.com/zones/${selectedZone}/circles/${selectedCircle}/clusters/${selectedCluster}/cities.json`, {
          name: cityName
        });
        alert('City added successfully');
        setCityName(''); // Clear the input field after successful submission
      } catch (error) {
        console.error('Error adding city:', error);
        alert('Error adding city');
      }
    } else {
      alert('Please fill all the details');
    }
  };

  return (
    <div className='bg-slate-50 p-4 h-screen'>
      <div className='bg-white p-4 shadow-xl rounded-xl'>
        <div className='font-semibold text-lg text-[#28507B]'>Add City Details</div>
        <div className='flex mt-8 gap-6'>
          <div className='w-1/2 '>
            <div className='text-slate-600'>Select Zone</div>
            <select
              value={selectedZone}
              onChange={(e) => setSelectedZone(e.target.value)}
              className='border w-full p-2 rounded-lg mt-2 text-slate-600'
            >
              <option value="">Select Zone</option>
              {zones.map(zone => (
                <option key={zone.id} value={zone.id}>{zone.name}</option>
              ))}
            </select>
            <div className='text-xs text-slate-500 font-semibold mt-1'>Select Zone</div>
          </div>
          <div className='w-1/2 '>
            <div className='text-slate-600'>Select Circle</div>
            <select
              value={selectedCircle}
              onChange={(e) => setSelectedCircle(e.target.value)}
              className='border w-full p-2 rounded-lg mt-2 text-slate-600'
            >
              <option value="">Select Circle</option>
              {circles.map(circle => (
                <option key={circle.id} value={circle.id}>{circle.name}</option>
              ))}
            </select>
            <div className='text-xs text-slate-500 font-semibold mt-1'>Select Circle</div>
          </div>
        </div>

        <div className='flex mt-6 gap-2 mb-6'>
          <div className='w-1/2 '>
            <div className='text-slate-600'>Select Cluster Name</div>
            <select
              value={selectedCluster}
              onChange={(e) => setSelectedCluster(e.target.value)}
              className='border w-full p-2 rounded-lg mt-2 text-slate-600'
            >
              <option value="">Select Cluster</option>
              {clusters.map(cluster => (
                <option key={cluster.id} value={cluster.id}>{cluster.name}</option>
              ))}
            </select>
            <div className='text-xs text-slate-500 font-semibold mt-1'>Select Cluster</div>
          </div>

          <div className='w-1/2'>
            <div className='text-slate-600'>Enter City Name</div>
            <input
              type="text"
              value={cityName}
              onChange={(e) => setCityName(e.target.value)}
              placeholder='City Name'
              className='border w-full p-2 rounded-lg mt-2 text-slate-600'
            />
            <div className='text-xs text-slate-500 font-semibold mt-1'>City Name Should be Alpha Numeric</div>
          </div>
        </div>
        <button
          onClick={handleAddCity}
          className='text-white bg-[#28507B] my-auto px-3 py-2 rounded-lg'
        >
          Add City Details
        </button>
      </div>
    </div>
  )
}

export default AddCityComponent;